<!-- Universal Post Component -->

<template>
	<div class="unipost">

		<div class="post-box">
			Posting data: {{ step }} 
		</div>

		<button v-if="!compData.autoPost" @click="goPost">Post {{ step }}</button> &nbsp;

		<div class="v-spacer"></div>

		<div v-for="(item, idx) in statusList" :key="'statusList'+idx">
			<div :class="idx==statusList.length-1? 'detail active': 'detail'">
				<div class="label-box">
					{{ item.step }}
				</div>
				<div class="icon-box">
					<UniIcon 
						:ico="calcIcon(item.trx).icon"
						fit="1"
						pad="2"
						:color="calcIcon(item.trx).color"
					/>
				</div>

				<div class="message-box">
					<div v-for="(mess, idx) in item.mess" :key="'statusListMess'+idx">
						{{ mess }}
					</div>
				</div>

			<div class="v-spacer"></div>

			</div>
	
		</div>

	</div>
</template>

<script>
import { m } from "@/utils/utils";
import { mapState, mapGetters } from "vuex";
import { eventBus } from '@/main';

export default {
	data() {
		return {
			step: "nothing",
			actions: {
				upload: "app/reqPostArt",
				current: "app/reqUpdateArt",
				contact: "app/reqPostContact",
				sweep: "app/reqSweep",
				stats: "app/reqStats",
			},
			icons: {
				wait: {icon:"stopwatch"	, color:"#F60"},
				100: {icon:"check"	, color:"#090"},
				fail: {icon:"notice", color:"#C30"},
			},
			statusList: [],

		}
	},
	props: {
		compData: { type: Object, default: function () {return {}} },
	},
	computed: {
		...mapState('app',['trxStatus']),
	},
	watch: {
		"compData": {
			deep: true,
			immediate: true,
			handler: function(newVal, oldVal) {
				m("unipost compdata changed to", newVal, typeof newVal);
				this.step = newVal.step; // save keystrokes
			}
		},
		"trxStatus": {
			deep: true,
			// immediate: true, // FALSE! don't show trxStatus at first load
			handler: function(newVal, oldVal) {
				m("unipost trx status changed to", newVal, typeof newVal);
				this.statusList = [...this.trxStatus];
			}
		},
	},
	methods: {
		goTest() {
			m("go test");
			eventBus.$emit("router", "/arts");
		},
		calcIcon(trx) {
			let ans = this.icons[trx] || this.icons.fail;
			m("ans", ans);
			return ans;
		},
		goPost() {
			let action = this.actions[this.step];
			m("go post " + this.step + ", " + action);
			this.$store.dispatch(action);
		},
	},
	mounted() {
		m("uni post mounted");
		if (this.compData.autoPost) this.goPost();
	},
	beforeDestroy() {
		m("uni post bef destroy");

		// Clear Post messages
		const data = {
			trx: "clear",
		}
		this.$store.dispatch("app/updTrxStatus", data );

		// Since this is a popup component, there is no access to this.$router
		// Main App component is listening for this event
		// this.$router.push("/arts");
		if (this.compData.autoPost) {
			if (this.step=="upload") eventBus.$emit("router", "/arts");
		}
	},
}
</script>

<style scoped>

.unipost {
	height: 100%;
	overflow: auto;
	padding: 5px;
	background-color: transparent;
	border: solid 0px #C30;
}

.detail {
	color: #666;
	padding: 5px 0px 0px 0px;
	background-color: #EEE;
	border: solid 0px #090;
}

.active {
	color: #000;
	font-weight: bold;
	background-color: #FFF;
}

.label-box {
	display: inline-block;
	width: 60px;
	height: 36px;
	overflow: hidden;
	vertical-align: top;
	padding: 5px 0px 0px 10px;
	border: solid 0px #999;
}

.icon-box {
	display: inline-block;
	width: 40px;
	height: 36px;
	overflow: hidden;
	vertical-align: top;
	border: solid 0px #999;
}

.post-box {
	display: inline-block;
	width: 180px;
	overflow: hidden;
	white-space: nowrap;
	vertical-align: top;
	border: solid 0px #999;

}

.message-box {
	display: inline-block;
	width: 280px;
	overflow: hidden;
	vertical-align: top;
	padding: 5px 0px 5px 10px;
	border: solid 0px #999;
}

.v-spacer {
	width: 90%;
	height: 10px;
	overflow: hidden;
	margin: auto;
	vertical-align: top;
	white-space: nowrap;
	padding: 5px;
	border: solid 0px #999;
	border-bottom: solid 1px #999;
}


</style>
